import NDVIMap from "./NDVIMap";

function NDVI() {
  return <NDVIMap />;
}

export default NDVI;
